// extracted by mini-css-extract-plugin
export var formContainer = "_jz-0";
export var message = "_jz-1";